
import _ from 'lodash';

class PrioritySorter {

    /**
     *
     * @param items {array}
     * @param name {string}
     * @returns {*}
     */
    sortByPriorityThen(items, name) {
        return _.chain(items)
            .sortBy(name)
            .reverse()
            .sortBy('priority.id')
            .reverse()
            .value();
    }
}
export default new PrioritySorter;
